<div class="dialog">

  <div class="dialog__header clickable">
    <span>Exportar</span>
    <mat-icon (click)="onCancel()">close</mat-icon>
  </div>
  <span>Escolha uma opção para exportar o orçamento.</span>

  <div class="dialog__container">

    <mat-radio-group aria-labelledby="example-radio-group-label" class="example-radio-group"
      [(ngModel)]="exportTypeFile">
      @for (file of optionsFile; track file) {
      <mat-radio-button class="example-radio-button" [value]="file">{{file}}</mat-radio-button>
      }
    </mat-radio-group>

    <button (click)="exportTypeSend(exportTypeFile)" class="edit_button" type="button">
      <span>Exportar</span>
    </button>
  </div>
</div>